import { render, staticRenderFns } from "./SpecialistDerivationUpdater.vue?vue&type=template&id=32972d4b&scoped=true&"
import script from "./SpecialistDerivationUpdater.vue?vue&type=script&lang=js&"
export * from "./SpecialistDerivationUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32972d4b",
  null
  
)

export default component.exports